import {
    getPartsListRequest,
    getPlacementListRequest,
    getServicesListRequest,
} from '../../../../services/network/search/region_services';

class CommonRegionSearchService {
    async getServicesSearchList(data) {
        return await getServicesListRequest(data);
    }

    async getPlacementSearchList(data) {
        return await getPlacementListRequest(data);
    }

    async getPartsSearchList(data) {
        return await getPartsListRequest(data);
    }
}

export const RegionSearchService = new CommonRegionSearchService();
